<p-dialog
  [(visible)]="boardFlag"
  [modal]="true"
  [responsive]="true"
  [styleClass]="'main-dialog'"
  (onHide)="closeDialog()"
>
  <div class="main-height">
    <div>
      <div class="p-fluid p-formgrid p-grid">
        <div class="p-col-12 p-md-12 p-jc-center">
          <p-table [value]="data">
            <ng-template pTemplate="header"> </ng-template>
            <ng-template pTemplate="body" let-data>
              <tr>
                <td class="bold legend">
                  <span class="bold">提案タイトル</span
                  >
                </td>
                <td >
                  {{ data?.title }}
                </td>
              </tr>
              <tr>
                <td class="bold legend">
                  <span class="bold">学年</span>
                </td>
                <td >
                  {{ data?.target_grade }}
                </td>
              </tr>
              <tr>
                <td class="bold legend">
                  <span class="bold">記録者</span>
                </td>
                <td >
                  {{ data?.organization_name }}
                </td>
              </tr>
              <tr>
                <td class="bold legend">
                  <span class="bold">実施日</span>
                </td>
                <td >
                  {{
                    data?.implementation_date
                      ? formatDateJapan(data?.implementation_date)
                      : ""
                  }}
                </td>
              </tr>
              <tr>
                <td class="bold legend">
                  <span class="bold"
                    >児童生徒の反応</span
                  >
                </td>
                <td >
                  {{ data?.comment }}
                </td>
              </tr>
              <tr>
                <td class="bold legend">
                  <span  class="bold">評価</span>
                </td>
                <td class="non-edit-cell-rate">
                  <div>
                    <div class="p-grid">
                      <div
                        class="p-col-12 p-d-flex p-ai-center list-rate-container"
                      >
                        <div
                          class="p-fluid p-formgrid p-grid p-d-flex p-ai-center p-jc-center list-rate-wraper"
                        >
                          <span class="p-col-2">良い</span>
                          <div class="list-rate p-col-8">
                            <div class="star-rate">
                              <span class="star-rate-number">5</span>
                              <span
                                class="circle"
                                *ngIf="data?.evaluation == '5'"
                              ></span>
                            </div>
                            <div class="star-rate">
                              <span class="star-rate-number">4</span>
                              <span
                                class="circle"
                                *ngIf="data?.evaluation == '4'"
                              ></span>
                            </div>
                            <div class="star-rate">
                              <span class="star-rate-number">3</span>
                              <span
                                class="circle"
                                *ngIf="data?.evaluation == '3'"
                              ></span>
                            </div>
                            <div class="star-rate">
                              <span class="star-rate-number">2</span>
                              <span
                                class="circle"
                                *ngIf="data?.evaluation == '2'"
                              ></span>
                            </div>
                            <div class="star-rate">
                              <span class="star-rate-number">1</span>
                              <span
                                class="circle"
                                *ngIf="data?.evaluation == '1'"
                              ></span>
                            </div>
                          </div>
                          <span class="p-col-2 list-rate-end">悪い</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <td class="bold legend">
                  <span  class="bold"
                    >評価の理由</span
                  >
                </td>
                <td >
                  {{ data?.reason }}
                </td>
              </tr>
            </ng-template>
          </p-table>
          <div class="p-col-12">
                <div class="p-d-flex p-jc-center">
                    <button
                        pButton
                        type="button"
                        label="閉じる"
                        (click)="closeDialog()"
                    ></button>
                </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</p-dialog>
